export const API_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : 'https://pizza-plaza.herokuapp.com';

export const FIREBASE_API_KEY = 'AIzaSyBHC3KTXgiPy3hS7J3zmAU5Ov9SND10TzA';